import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { UserAuthDto } from "../../shared/model/user.model";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // The BehaviorSubject will hold the current user
  private currentUserSubject = new BehaviorSubject<UserAuthDto | null>(null);

  constructor(    private router: Router  ) {  }

  public updateCurrentUser(user: UserAuthDto): void {
    localStorage.setItem('currentUser', JSON.stringify(user));
    localStorage.setItem('bearerToken', user.bearerToken);
    this.currentUserSubject.next(user);
  }
  getToken(): string | null {
    return localStorage.getItem("bearerToken");
  }

  public getCurrentUserValue(): UserAuthDto | null {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      return JSON.parse(currentUser);
    }
    return null; 
  }
  resetSecurityObject(): void {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('bearerToken');
    this.router.navigate(['/auth/sign-up']);

  }

  public hasClaim(claimType: any, claimValue?: any): boolean {
    
    let ret = false;
    if (typeof claimType === 'string') {
      ret = this.isClaimValid(claimType, claimValue);
    } else {
      const claims: string[] = claimType;
      if (claims) {
        for (let index = 0; index < claims.length; index++) {
          ret = this.isClaimValid(claims[index]);
          if (ret) {
            break;
          }
        }
      }
    }
    return ret;
  }

  private isClaimValid(claimType: string, claimValue?: string): boolean {
    let ret = false;
    let auth: UserAuthDto ;
    // Retrieve security object
    const authStr = localStorage.getItem('currentUser');
    if (authStr) {
      auth = JSON.parse(authStr);
      // See if the claim type has a value
      // *hasClaim="'claimType:value'"
      if (claimType.indexOf(':') >= 0) {
        const words: string[] = claimType.split(':');
        claimType = words[0].toLowerCase();
        claimValue = words[1];
      } else {
        claimType = claimType.toLowerCase();
        // Either get the claim value, or assume 'true'
        claimValue = claimValue ? claimValue : 'true';
      }
      // Attempt to find the claim
      ret =
        auth.claims?.find(
          (c : any) =>
            c.claimType && c.claimType.toLowerCase() == claimType && c.claimValue == claimValue
        ) != null;
    }
    return ret;
  }

}
